import React from "react";

import {EllipsisOutlined} from "@ant-design/icons";
import {Button, Dropdown} from "antd";

export function ActionsMenu({actions}) {
	return (
		<Dropdown overlay={actions}>
			<p style={{paddingTop: 5}} onClick={e => e.preventDefault()}>
				<Button>
					<EllipsisOutlined />
				</Button>
			</p>
		</Dropdown>
	);
}
